import React from 'react';
import { connect } from 'react-redux';

const LoadingPanel = (props) => (
  <div>
    <div className={`${props.isLoading ? 'loadingPanel visible' : 'loadingPanel invisible'}`}>
      <div className="bg--black one-whole absolute" style={{ height: '100%', top: '0', opacity: '0.5' }}> </div>
      <div className="loading">
        <div className="dot"></div>
        <div className="dot2"></div>
        <div className="dot3"></div>
      </div>
      <div className="mt--"></div>
    </div>
  </div>
);

export default connect(state => state.AppState)(LoadingPanel);



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/LoadingPanel.js
 **/